import ReactApexChart from "react-apexcharts";
import { ADCubeAdminContext } from "../../../../context/ADCubeAdminContext";
import { useContext } from "react";

export const BudgetOptProjectChart = ({ budgetOptData, xLabel, yLabel }) => {
  const markerPoints = [];
  const adCubeAdminContext = useContext(ADCubeAdminContext);

  if (budgetOptData && budgetOptData.x_historical_data) {
    for (let i = 0; i < budgetOptData.x_historical_data.length; i++) {
      markerPoints.push({
        x: budgetOptData.x_historical_data[i],
        y: budgetOptData.y_historical_data[i],
        marker: {
          size: 2,
          fillColor: "#fff",
          strokeColor: "blue",
          radius: 2,
          cssClass: "apexcharts-custom-class",
        },
      });
    }
  }

  const allX = budgetOptData.x_historical_data
    ? [...budgetOptData.input_data, ...budgetOptData.x_historical_data]
    : budgetOptData.input_data;
  const allY = budgetOptData.y_historical_data
    ? [
        ...budgetOptData.target_data_lq,
        ...budgetOptData.target_data_mn,
        ...budgetOptData.target_data_uq,
        ...budgetOptData.y_historical_data,
      ]
    : [
        ...budgetOptData.target_data_lq,
        ...budgetOptData.target_data_mn,
        ...budgetOptData.target_data_uq,
      ];
  const xMin = Math.min(...allX);
  const xMax = Math.max(...allX);
  const yMin = Math.min(...allY);
  const yMax = Math.max(...allY);
  const yPadding = (yMax - yMin) * 0.05;

  const options = {
    chart: {
      height: 350,
      type: "rangeArea",
      zoom: {
        enabled: false,
      },
      background: "transparent",
    },
    theme: {
      mode: adCubeAdminContext.themeLight ? "light" : "dark",
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#7367F0", "#7367F0"],
    stroke: {
      curve: "straight",
      width: [0, 2],
    },
    fill: {
      opacity: [0.24, 1],
    },
    xaxis: {
      min: xMin,
      max: xMax,
      title: {
        text: xLabel,
      },
      type: "numeric",
      tickAmount: 50,
    },
    grid: {
      position: "back",
      borderColor: "#90A4AE",
      /*       yaxis: {
        lines: {
          show: false,
        },
      }, */
      row: {
        opacity: 0.9,
      },
      column: {
        opacity: 0.9,
      },
    },
    legend: {
      show: false,
    },
    yaxis: {
      min: yMin - yPadding,
      max: yMax + yPadding,
      title: {
        text: yLabel,
      },
      tickAmount: 5,
    },
    title: {
      text: budgetOptData.item_name,
    },
    annotations: {
      points: markerPoints,
    },
  };

  const series = [
    {
      type: "rangeArea",
      name: `${budgetOptData.item_name} range`,

      data: budgetOptData.input_data.map((item, index) => {
        return {
          x: parseFloat(item.toFixed(2)),
          y: [
            parseFloat(budgetOptData.target_data_lq[index].toFixed(2)),
            parseFloat(budgetOptData.target_data_uq[index].toFixed(2)),
          ],
        };
      }),
    },
    {
      type: "line",
      name: `${budgetOptData.item_name} median`,
      data: budgetOptData.input_data.map((item, index) => {
        return {
          x: parseFloat(item.toFixed(2)),
          y: parseFloat(budgetOptData.target_data_mn[index].toFixed(2)),
        };
      }),
    },
  ];

  return (
    <ReactApexChart
      options={options}
      series={series}
      type="rangeArea"
      height={350}
    />
  );
};
